(function () {
  'use strict';

  var recommendationRequests = new WeakMap();
  var hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function elementsWithin(scope, selector) {
    var elements = [];

    if (scope instanceof Element && scope.matches(selector)) {
      elements.push(scope);
    }

    return elements.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
  }

  function initializeSecondaryImages(scope) {
    if (!hoverMedia.matches || reducedMotion.matches) return;

    elementsWithin(scope, '[data-product-card]').forEach(function (card) {
      if (card.dataset.secondaryImageInitialized === 'true') return;

      var image = card.querySelector('[data-secondary-src]');
      if (!image) return;

      card.dataset.secondaryImageInitialized = 'true';

      card.addEventListener('pointerenter', function () {
        if (image.dataset.loaded === 'true') return;

        image.dataset.loaded = 'true';

        var markReady = function () {
          card.classList.add('is-secondary-ready');
        };

        image.addEventListener('load', markReady, { once: true });

        if (image.dataset.secondarySizes) {
          image.sizes = image.dataset.secondarySizes;
        }
        if (image.dataset.secondarySrcset) {
          image.srcset = image.dataset.secondarySrcset;
        }
        image.src = image.dataset.secondarySrc;

        if (image.complete && image.naturalWidth > 1) {
          markReady();
        }
      }, { once: true, passive: true });
    });
  }

  function initializeSortForms(scope) {
    elementsWithin(scope, '[data-catalog-sort]').forEach(function (form) {
      if (form.dataset.catalogSortInitialized === 'true') return;

      var select = form.querySelector('[data-catalog-sort-select]');
      if (!select) return;

      form.dataset.catalogSortInitialized = 'true';
      select.addEventListener('change', function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  }

  function initializeRecommendations(scope) {
    elementsWithin(scope, '[data-recommendations-root]').forEach(function (root) {
      if (root.dataset.recommendationsInitialized === 'true') return;

      var url = root.dataset.url;
      if (!url) return;

      root.dataset.recommendationsInitialized = 'true';
      root.setAttribute('aria-busy', 'true');

      var controller = new AbortController();
      recommendationRequests.set(root, controller);

      fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
        signal: controller.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Recommendation request failed');
          return response.text();
        })
        .then(function (html) {
          if (!root.isConnected) return;

          var documentFragment = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = documentFragment.querySelector('[data-recommendations-root]');
          var freshList = freshRoot && freshRoot.querySelector('[data-recommendations-list]');
          var currentList = root.querySelector('[data-recommendations-list]');
          var freshCount = freshList ? Number(freshList.dataset.recommendationCount || 0) : 0;
          var currentCount = currentList ? Number(currentList.dataset.recommendationCount || 0) : 0;

          if (freshList && freshCount > 0 && currentList) {
            currentList.replaceWith(freshList);
            root.hidden = false;
            initializeSecondaryImages(root);
          } else if (currentCount === 0) {
            root.hidden = true;
          }
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            root.dataset.recommendationsError = 'true';
          }
        })
        .finally(function () {
          if (root.isConnected) {
            root.removeAttribute('aria-busy');
          }
          recommendationRequests.delete(root);
        });
    });
  }

  function initializeCatalog(scope) {
    initializeSecondaryImages(scope);
    initializeSortForms(scope);
    initializeRecommendations(scope);
  }

  function unloadCatalog(scope) {
    elementsWithin(scope, '[data-recommendations-root]').forEach(function (root) {
      var controller = recommendationRequests.get(root);
      if (controller) controller.abort();
      recommendationRequests.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeCatalog(document);
    }, { once: true });
  } else {
    initializeCatalog(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeCatalog(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unloadCatalog(event.target);
  });
})();

